import { render, staticRenderFns } from "./CreditsModalCardInfoForm.vue?vue&type=template&id=13e38e4f&scoped=true&"
import script from "./CreditsModalCardInfoForm.vue?vue&type=script&lang=js&"
export * from "./CreditsModalCardInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./CreditsModalCardInfoForm.vue?vue&type=style&index=0&id=13e38e4f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e38e4f",
  null
  
)

export default component.exports